export default [
  {
    check: false,
    title: "사무직",
    list: [
      {
        content: "허리는 곧게 펴고 의자 등받이에 지지되도록 앉았는가?",
        isChecked: "",
      },
      {
        content: "눈높이는 화면 상단과 일치하도록 맞추며, 수시로 휴식 시간을 갖고 스트레칭을 실시하는가?",
        isChecked: "",
      },
      {
        content: "책상 높이는 팔꿈치 높이 정도로 조절하고 키보드와 마우스는 손목이 꺾이지 않도록 유지하는가?",
        isChecked: "",
      },
      {
        content: "여러 겹의 종이 또는 두꺼운 물건을 칼로 자를 때는 한 번에 힘을 주지 않고 여러 번 걸쳐 자르는가?",
        isChecked: "",
      },
      {
        content: "무거운 물건은 2인 이상 함께 들어 올리는가?",
        isChecked: "",
      },
      {
        content: "사무실 업무중 긁힘 등의 상해 발생시 2차 감염 예방을 위한 비상구급함이 비치되어 있는가?",
        isChecked: "",
      },
      {
        content: "캐비닛 또는 문서보관함 최상단에 불안전하게 쌓아 놓은 물건이 떨어질 위험이 없는가?",
        isChecked: "",
      },
      {
        content: "민원인과 문제 상황 발생 시 대처방법 등 포함하는 고객응대업무 매뉴얼을 비치하고 있는가?",
        isChecked: "",
      },
      {
        content: "감정노동 심리적 스트레스에 대한 교육 및 대처방안 교육을 실시하고 있는가?",
        isChecked: "",
      },
      {
        content: "콘센트 분진적재 등 으로 화재 위험은 없는가?",
        isChecked: "",
      },
      {
        content: "습윤발생구간(정수기, 화장실등)  전기기기를 사용하지 않고 있는가? ",
        isChecked: "",
      },
      {
        content: "바닥에 이물질 ,물건등으로 통행 시 넘어질 우려가 없는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "시설물 경비",
    list: [
      {
        content: "야간 순찰시 랜턴, 야광조끼, 야광봉 등 챙겼는가?",
        isChecked: "",
      },
      {
        content: "계단을 오르내릴 때 손잡이를 잡는가?",
        isChecked: "",
      },
      {
        content: "주머니에 손을 넣고 경사, 결빙, 어두운 곳을 순찰하지 않는가?",
        isChecked: "",
      },
      {
        content: "통로는 충분히 밝은가?",
        isChecked: "",
      },
      {
        content: "통로는 정리정돈 되어 걸려 넘어질 위험이 없는가?",
        isChecked: "",
      },
      {
        content: "계단은 파손부위가 없고 미끄럼방지 조치를 하였는가?",
        isChecked: "",
      },
      {
        content: "무거운 물체 운반 시 2인 1조로 작업을 실시하는가?",
        isChecked: "",
      },
      {
        content: "올바른 중량물 취급방법에 대해 알고 있는가?",
        isChecked: "",
      },
      {
        content: "작업 전·중·후 주기적으로 스트레칭을 하는가?",
        isChecked: "",
      },
      {
        content: "차량안내 및 유도 시 안전한 위치에서 실시하였는가?",
        isChecked: "",
      },
      {
        content: "민원인과 문제 상황 발생 시 대처방법 등을 포함하는 고객응대 업무 매뉴얼을 비치하고 있는가?",
        isChecked: "",
      },
      {
        content: "감정노동 심리적 스트레스에 대한 교육 및 대처방안 교육을 실시하고 있는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "시설물청소",
    list: [
      {
        content: "필요한 보호구 지급 및 착용을 하였는가?",
        isChecked: "",
      },
      {
        content: "계단을 오르내일때 손잡이를 잡고 다니는가?",
        isChecked: "",
      },
      {
        content: "계단에 파손부위가 없고 미끄럼방지 조치를 하였는가?",
        isChecked: "",
      },
      {
        content: "슬리퍼를 착용하거나 신발을 꺾어 신지 않았는가?",
        isChecked: "",
      },
      {
        content: "작업도구나 자재를 수시로 정리하여 통로를 확보하였는가",
        isChecked: "",
      },
      {
        content: "바닥에 작업자가 걸려 넘어질 위험이 있는 장애물은 제거하였는가?",
        isChecked: "",
      },
      {
        content: "사다리가 넘어지거나 미끄러지지 않도록 조치하고 2인1조로 작업하는가?",
        isChecked: "",
      },
      {
        content: "천정이나 높은 벽청소 시 사용하는 사다리에 미끄럼방지조치를 하는가?",
        isChecked: "",
      },
      {
        content: "근로자의 통행에 방해가 없도록 채광 또는 조명시설이 충분한가?",
        isChecked: "",
      },
      {
        content: "다른사람과의 충돌을 방지하기 위해 우측통행을 하는가?",
        isChecked: "",
      },
      {
        content: "바닥타일이 깨지거나 비어있는 부분은 없는가?",
        isChecked: "",
      },
      {
        content: "청소기나 연마기를 방수형 콘센트 및 플러그에 연결해 사용하는가?",
        isChecked: "",
      },
      {
        content: "이동전선에 누전차단기를 설치하고 접지를 하였는가?",
        isChecked: "",
      },
      {
        content: "청소용구 운반카트에 브레이크 설치하였는가?",
        isChecked: "",
      },
      {
        content: "광태기, 연마기, 청소차 등의 관리자(운전자)를 지정했는가?",
        isChecked: "",
      },
      {
        content: "박리제, 광택제, 등 피부자극성 물질 사용 중 충분히 환기를 하였는가?",
        isChecked: "",
      },
      {
        content: "세면대나 변기 위에 올라가서 작업을 하지 않는가?",
        isChecked: "",
      },
      {
        content: "물청소, 왁스작업시 미끄럼주의 표지 설치하였는가?",
        isChecked: "",
      },
      {
        content: "청소 중에는 미끄럼 방지용 장화를 착용하는가?",
        isChecked: "",
      },
      {
        content: "자극성 세제를 이용한 청소 시 고무장갑을 착용하는가?",
        isChecked: "",
      },
      {
        content: "청소 후 바닥에 미끄러운 세제나 물기를 깨끗이 제거하였는가",
        isChecked: "",
      },
      {
        content: "청소도구를 지정된 위치에 보관하는가?",
        isChecked: "",
      },
      {
        content: "같은 자세로 오랫동안 작업하지 않고 틈틈이 짧은 휴식을 취하도록 하는가?",
        isChecked: "",
      },
      {
        content: "중량물 취급 시 2인1조로 작업하거나 대차를 사용하는가?",
        isChecked: "",
      },
      {
        content: "작업 중 수시로 스트레칭을 하는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "시설물 유지관리",
    list: [
      {
        content: "위험작업 시 안전모, 안전화 등 개인보호구를 착용하는가?",
        isChecked: "",
      },
      {
        content: "사다리 작업 시 안전한 작업방법(2인1조 작업, 안전한 구조의 사다리 사용 등)을 숙지하고 있는가?",
        isChecked: "",
      },
      {
        content: "각종 계기류 확인 시 감전 예방을 위한 절연장갑을 착용하는가?",
        isChecked: "",
      },
      {
        content: "기계 점검, 보수 시 동력원을 완전히 차단한 후 작업하는가?",
        isChecked: "",
      },
      {
        content: "배관 등 지지대  노후 및 훼손으로 붕괴 위험이 없는가?",
        isChecked: "",
      },
      {
        content: "각종 전기기구 작업 시 작업자가 감전사고에 대한 작업방법을 확실하게 인지하고 있는가?",
        isChecked: "",
      },
      {
        content: "화학물질 취급 및 저장 시 별도의 지정된 장소에 보관하는가?",
        isChecked: "",
      },
      {
        content: "무거운 물체 운반 시 2인1조로 작업을 실시하는가?",
        isChecked: "",
      },
      {
        content: "올바른 중량물 취급방법에 대해 알고 있는가?",
        isChecked: "",
      },
      {
        content: "작업 전·중·후 주기적으로 스트레칭을 하는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "조경작업(예초기)",
    list: [
      {
        content: "보호구 지급 및 착용을 하였는가?",
        isChecked: "",
      },
      {
        content: "벌·해충 등에 대한 약제 및 기피제 등을 지급하였는가?",
        isChecked: "",
      },
      {
        content: "구급약품 및 용구를 비치하였는가?",
        isChecked: "",
      },
      {
        content: "예초기의 날 접촉예방장치를 부착하였는가?",
        isChecked: "",
      },
      {
        content: "예초기 시동 시 주변근로자 접근을 금지하고 주변 장애물에 부딪히지 않게 하고 있는가?",
        isChecked: "",
      },
      {
        content: "예초기 작업 시 안전거리 10m 이상 확보 하였는가?",
        isChecked: "",
      },
      {
        content: "예초기 날이 돌 또는 굵은 나무 등의 방해물에 부딪히지 않는가?",
        isChecked: "",
      },
      {
        content: "예초기를 우측에서 좌측방향으로 하는가?",
        isChecked: "",
      },
      {
        content: "급경사지에서 작업하지 않고 있는가?",
        isChecked: "",
      },
      {
        content: "예초기를 들고 이동시 근로자와 안전거리 확보하고 이동하는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "조경작업(낫 사용 작업)",
    list: [
      {
        content: "보호구 지급 및 착용을 하였는가?",
        isChecked: "",
      },
      {
        content: "벌·해충 등에 대한 약제 및 기피제 등을 지급하였는가?",
        isChecked: "",
      },
      {
        content: "구급약품 및 용구를 비치하였는가?",
        isChecked: "",
      },
      {
        content: "낫날의 연마가 잘 되어있는가?",
        isChecked: "",
      },
      {
        content: "낫날과 몸체 연결부 고정상태가 양호한가?",
        isChecked: "",
      },
      {
        content: "낫 작업 시 무리한 힘을 가하지 않는가?",
        isChecked: "",
      },
      {
        content: "주변 근로자와 안전거리는 3m 이상 확보되었는가?",
        isChecked: "",
      },
      {
        content: "한쪽 발을 굽히고 다리를 벌려 허리에 부담을 주지 않는 등 올바른 자세로 작업을 하고 있는가?",
        isChecked: "",
      },
      {
        content: "급경사지에서 작업하지 않고 있는가?",
        isChecked: "",
      },
      {
        content: "낫을 들고 이동시 낫날에 보호덮개를 부착하였는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "조경작업(가지치기)",
    list: [
      {
        content: "보호구 지급 및 착용을 하였는가?",
        isChecked: "",
      },
      {
        content: "벌·해충 등에 대한 약제 및 기피제 등을 지급하였는가?",
        isChecked: "",
      },
      {
        content: "구급약품 및 용구를 비치하였는가?",
        isChecked: "",
      },
      {
        content: "어깨높이 이상 기계톱을 사용하지 않고 있는가?",
        isChecked: "",
      },
      {
        content: "낫 날과 몸체 연결부 고정상태가 양호한가?",
        isChecked: "",
      },
      {
        content: "고지톱과 작업자의 각도가 45˚를 유지하는가?",
        isChecked: "",
      },
      {
        content: "고소작업시 안전대 착용 등 추락방지 조치를 하였는가?",
        isChecked: "",
      },
      {
        content: "작업자간 15m 이상의 안전거리를 확보하였는가?",
        isChecked: "",
      },
      {
        content: "급경사지에서 작업하지 않고 있는가?",
        isChecked: "",
      },
      {
        content: "고지톱 등을 들고 이동시 날에 보호덮개를 부착하였는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "조경작업(기계톱)",
    list: [
      {
        content: "보호구 지급 및 착용을 하였는가?",
        isChecked: "",
      },
      {
        content: "(안전모, 안전화, 귀마개, 무릎보호대, 방진장갑 등)",
        isChecked: "",
      },
      {
        content: "안전모, 작업복 등은 눈에 잘 띄는 색깔인가?",
        isChecked: "",
      },
      {
        content: "구급약품 및 용구를 비치하였는가?",
        isChecked: "",
      },
      {
        content: "체인브레이크가 정상 작동 되고 있는가?",
        isChecked: "",
      },
      {
        content: "체인 잡이가 정상상태인가?",
        isChecked: "",
      },
      {
        content: "톱날윤활 및 연마 상태가 정상인가?",
        isChecked: "",
      },
      {
        content: "후방보호가드 파손 여부 등 기계톱에 이상이 없는가?",
        isChecked: "",
      },
      {
        content: "기계톱 시동 시 주변에 근로자와 장애물과 3m 이격하여 하였는가?",
        isChecked: "",
      },
      {
        content: "기계톱 작업과 관련한 교육은 충분히 받았는가?",
        isChecked: "",
      },
      {
        content: "기계톱을 들고 이동시 정지 또는 체인브레이크가 걸린 상태인가?",
        isChecked: "",
      },
      {
        content: "벌목작업시 위험반경 내 다른 작업자 확인및 신호 준수하는가?<br/>- 대상목을 중심으로 2배 이상의 안전거리 확보",
        isChecked: "",
      },
      {
        content: "벌목작업시 수수각 따기 작업절차를 준수하는가?",
        isChecked: "",
      },
      {
        content: "걸린 나무를 받치고 있는 나무 벌목시 걸린나무를 우선 안전하게 처리후 작업하는가?",
        isChecked: "",
      },
      {
        content: "벌도목이 굴러 넘어질 위험이 있는 장소는 상·하 동시작업 금지를 하는가?",
        isChecked: "",
      },
      {
        content: "벌목작업전 대피장소를 정하고 벌도목이 넘어가기 시작하면 신속히 대피하는가?",
        isChecked: "",
      },
      {
        content: "기계톱 사용시 킥백방지 등 올바른 사용방법을 숙지하였는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "조리작업",
    list: [
      {
        content: "작업장 바닥에 물기가 있지는 않는가?",
        isChecked: "",
      },
      {
        content: "왁스 등 청결작업으로 인해 넘어지는 사고 발생의 위험의 예방조치(안전표지 설치 등)는 적절한가?",
        isChecked: "",
      },
      {
        content: "작업장 바닥의 트렌치로 인해 발이 걸려 넘어질 위험은 없는가?",
        isChecked: "",
      },
      {
        content: "작업장 바닥에 기름기로 인해 넘어지는 사고 발생의 위험은 없는가?",
        isChecked: "",
      },
      {
        content: "작업장 바닥에 턱이 있는 곳은 없는가?",
        isChecked: "",
      },
      {
        content: "작업장 바닥에 릴호수 등이 방치되어 있어 작업자가 발이 걸려 넘어질 위험은 없는가?",
        isChecked: "",
      },
      {
        content: "작업장 바닥에 비닐 등이 널려 있어 미끄러질 위험은 없는가?",
        isChecked: "",
      },
      {
        content: "작업장 바닥에 물기제거용 매트가 고정되어 있는가?",
        isChecked: "",
      },
      {
        content: "작업자는 미끄럼방지용 장화를 착용하고 있는가?",
        isChecked: "",
      },
      {
        content: "작업장 바닥은 미끄럼 방지조치가 되어 있는가?",
        isChecked: "",
      },
      {
        content: "선반에서 식재료가 떨어질 위험은 없는가?",
        isChecked: "",
      },
      {
        content: "선반에 식재료를 적재하는 경우 떨어질 위험은 없는가?",
        isChecked: "",
      },
      {
        content: "선반 사이의 통로에서 작업자와 이동대차 등이 부딪힐 위험은 없는가?",
        isChecked: "",
      },
      {
        content: "선반에 식재료 과다적재로 인한 붕괴 위험은 없는가?",
        isChecked: "",
      },
      {
        content: "선반 사이의 통로에 작업자 보행이동 시 넘어질 위험은 없는가?",
        isChecked: "",
      },
      {
        content: "선반에 휨, 비틀림 등이 발생되지 않았는가?",
        isChecked: "",
      },
      {
        content: "작업 시 보호구는 착용하는가?",
        isChecked: "",
      },
      {
        content: "선반 주변에 잡자재가 방치되어 있지는 않는가?",
        isChecked: "",
      },
      {
        content: "선반 주위에 보행통로와 작업통로가 구분되어 있는가?",
        isChecked: "",
      },
      {
        content: "호스에서 가스가 누설되고 있지는 않는가?",
        isChecked: "",
      },
      {
        content: "가스누출 자동차단기 및 누설경보기 작동상태는 양호한가?",
        isChecked: "",
      },
      {
        content: "호스의 상태는 양호한가?",
        isChecked: "",
      },
      {
        content: "가스호스의 각 연결부위의 상태는 양호한가?",
        isChecked: "",
      },
      {
        content: "가스테이블이 작업대에서 떨어질 위험은 없는가?",
        isChecked: "",
      },
      {
        content: "가스테이블의 호스에 작업자의 발이 걸려 넘어질 위험은 없는가?",
        isChecked: "",
      },
      {
        content: "조리도구를 올리거나 내릴 때 안전하게 작업을 하고 있는가?",
        isChecked: "",
      },
      {
        content: "가스테이블 앞 작업공간은 충분하게 확보되어 있는가?",
        isChecked: "",
      },
      {
        content: "가스테이블 작업대 바닥에 물기는 제거되어 있는가?",
        isChecked: "",
      },
      {
        content: "작업장 환기는 실시하는가?",
        isChecked: "",
      },
      {
        content: "작업 용도에 적합한 칼과 도마를 사용하고 있는가?",
        isChecked: "",
      },
      {
        content: "칼날은 작업에 적합할 만큼 날카로움을 유지하고 있는가?",
        isChecked: "",
      },
      {
        content: "식칼을 옮길 때에는 칼집이나 칼꽂이를 이용하여 운반하고 있는가?",
        isChecked: "",
      },
      {
        content: "작업 중 흡연, 잡담, 휴대폰 통화 등 불필요한 행동을 금지하고 있는가?",
        isChecked: "",
      },
      {
        content: "절단, 다듬기, 뼈 발라내기를 할 때 칼의 방향은 몸 바깥쪽을 향하고 있는가?",
        isChecked: "",
      },
      {
        content: "칼을 병이나 캔 따개 등 다른 용도로 이용하지는 않는가?",
        isChecked: "",
      },
      {
        content: "칼 사용 후 작업대 위에 걸쳐서 방치하지는 않는가?",
        isChecked: "",
      },
      {
        content: "칼 손잡이에서 손이 미끄러질 위험은 없는가?",
        isChecked: "",
      },
      {
        content: "장시간 칼 작업으로 어깨 결림 등의 위험은 없는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "탁상용 연삭기",
    list: [
      {
        content: "연삭숫돌 사용전 손상유무는 없는가?",
        isChecked: "",
      },
      {
        content: "연삭숫돌에 충격이 가지 않도록 작업하는가?",
        isChecked: "",
      },
      {
        content: "연삭숫돌은 규격에 맞는 크기의 것을 규정 속도로 사용하는가?",
        isChecked: "",
      },
      {
        content: "방호덮개를 부착한 상태에서 작업하는가?",
        isChecked: "",
      },
      {
        content: "작업시에는 보안경을 착용하는가?",
        isChecked: "",
      },
      {
        content: "연삭기의 노출각도는 90º이거나 전체 원주의 1/4를 초과하지 않는가?",
        isChecked: "",
      },
      {
        content: "연삭숫돌의 교체시에는 3분이상, 작업시작전 1분 이상 시운전후 작업하는가?",
        isChecked: "",
      },
      {
        content: "연삭숫돌에 무리한 힘을 가하지 않는가?",
        isChecked: "",
      },
      {
        content: "측면사용을 목적으로 제작된 연삭숫돌 이외에는 측면사용을 금지하는가?",
        isChecked: "",
      },
      {
        content: "폭발위험이 있는 장소에서 연삭작업을 하는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "직류아크용접기",
    list: [
      {
        content: "케이블(전선)의 피복의 손상은 없는가?",
        isChecked: "",
      },
      {
        content: "케이블(전선)의 용접기와 접속부의 부착, 절연상태가 양호한가?",
        isChecked: "",
      },
      {
        content: "케이블(전선)은 전류용량에 적합한 것을 사용하는가?",
        isChecked: "",
      },
      {
        content: "용접기 본체에 접지선이 연결되어 있는가?",
        isChecked: "",
      },
      {
        content: "용접작업중 작업자가 보행이동시 넘어질 위험이 없는가?",
        isChecked: "",
      },
      {
        content: "물기 있는 장갑, 작업복, 신발을 착용하지 않는가?",
        isChecked: "",
      },
      {
        content: "용접작업장 인접한 곳에 인화성물질이 방치하지 않도록 하는가?",
        isChecked: "",
      },
      {
        content: "작업장 내 환기는 충분히 하는가?",
        isChecked: "",
      },
      {
        content: "작업중 주변의 정리정돈을 실시하는가?",
        isChecked: "",
      },
      {
        content: "앞치마, 보안경, 보안면, 방진마스크 등 보호구를 착용하는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "산소절단기",
    list: [
      {
        content: "각종 호스와 취관은 손상·마모가 없는것을 사용하는가?",
        isChecked: "",
      },
      {
        content: "호스밴드 및 호스클립의 체결상태는 양호한가?",
        isChecked: "",
      },
      {
        content: "작업시 불받이포를 사용하는가?",
        isChecked: "",
      },
      {
        content: "작업장 주변에 인화성·가연성 물질을 제거하였는가?",
        isChecked: "",
      },
      {
        content: "작업중 토치부가 호스에 접근하지 않도록 하는가?",
        isChecked: "",
      },
      {
        content: "작업을 중단하거나 종료하고 작업장소를 떠날때 가스 등의 공급구의 밸브 또는 콕을 잠궜는가?",
        isChecked: "",
      },
      {
        content: "가스조절 밸브를 서서히 조작하는가?",
        isChecked: "",
      },
      {
        content: "작업장소 주변에 소화기 등을 비치하는가?",
        isChecked: "",
      },
      {
        content: "고압용기의 넘어짐 방지조치를 실시하는가?",
        isChecked: "",
      },
      {
        content: "작업자는 보안면 및 방진마스크를 착용하는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "휴대용연삭기",
    list: [
      {
        content: "연삭숫돌 사용전 손상은 없는가?",
        isChecked: "",
      },
      {
        content: "연삭숫돌에 충격이 가지 않도록 작업하는가?",
        isChecked: "",
      },
      {
        content: "연삭숫돌의 교체후에는 3분이상 무부하 시운전을 하는가?",
        isChecked: "",
      },
      {
        content: "연삭숫돌은 규격에 맞는 크기의 것을 규정속도로 사용하는가?",
        isChecked: "",
      },
      {
        content: "연삭숫돌에 말릴 우려가 있는 장갑(코팅)을 착용하지 않는가?",
        isChecked: "",
      },
      {
        content: "방호덮개를 부착한 상태에서 작업하는가?",
        isChecked: "",
      },
      {
        content: "작업시에는 보안경을 착용하는가?",
        isChecked: "",
      },
      {
        content: "이동시에는 휴대용연삭기의 작동을 중지하는가?",
        isChecked: "",
      },
      {
        content: "연삭숫돌에 무리한 힘을 가하지 않는가?",
        isChecked: "",
      },
      {
        content: "폭발위험이 있는 장소에서는 연삭작업을 하지 않는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "금속절단기",
    list: [
      {
        content: "안전커버 및 벨트 덮개가 견고하게 부착되어 있는가?",
        isChecked: "",
      },
      {
        content: "전원케이블의 손상은 없는가?",
        isChecked: "",
      },
      {
        content: "절단석의 균열이나 이빠짐 등 손상은 없는가?",
        isChecked: "",
      },
      {
        content: "가공물은 고정장치 등을 이용하여 견고하게 고정하고 작업을 실시하는가?",
        isChecked: "",
      },
      {
        content: "절단 불티 비산 방향을 확인하여 비산 방지 조치를 실시하는가?",
        isChecked: "",
      },
      {
        content: "가공물 교체 또는 이상 조치는 절단기를 정지한 상태에서 실시하는가?",
        isChecked: "",
      },
      {
        content: "귀마개, 보안경, 및 방진 마스크를 착용하고 작업을 실시하는가?",
        isChecked: "",
      },
      {
        content: "절단작업시 숫돌에 충격이 가지 않도록 하는가?",
        isChecked: "",
      },
      {
        content: "절단작업 시작전 1분정도 덮개를 설치한 상태로 공회전을 시키는가?",
        isChecked: "",
      },
      {
        content: "절단기의 회전속도에 상응하는 숫돌을 사용하는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "이동식둥근톱",
    list: [
      {
        content: "작업장 바닥의 수평상태를 확인하였는가?",
        isChecked: "",
      },
      {
        content: "톱날고정 플랜지 등의 부착상태를 확인하였는가?",
        isChecked: "",
      },
      {
        content: "톱날의 균열여부를 확인하였는가?",
        isChecked: "",
      },
      {
        content: "공회전으로 이상유무를 확인하였는가?",
        isChecked: "",
      },
      {
        content: "톱날의 노출각도(180º)이내로 방호덮개를 설치하였는가?",
        isChecked: "",
      },
      {
        content: "전선 피복의 손상 유무를 확인하였는가?",
        isChecked: "",
      },
      {
        content: "개인보호구(안전화, 보안경, 방진마스크, 귀마개, 방진장갑 등)를 착용하였는가?",
        isChecked: "",
      },
      {
        content: "가공물 고정 상태를 확인하였는가?",
        isChecked: "",
      },
      {
        content: "본체 외함 접지 및 누전차단기 접속 유무를 확인하였는가?",
        isChecked: "",
      },
      {
        content: "전선을 잡고 공구 이동을 금지하였는가?(전선 접속부 이완 및 피복손상)",
        isChecked: "",
      },
      {
        content: "작동시 기계정비를 금지하였는가?",
        isChecked: "",
      },
      {
        content: "가공재 밀대 등 보조 도구를 사용하는가?",
        isChecked: "",
      },
      {
        content: "작업반경 내 타 근로자의 접근을 금지하였는가?",
        isChecked: "",
      },
      {
        content: "설비 이상시 전원을 끈 상태에서 점검 및 수리를 하는가?",
        isChecked: "",
      },
      {
        content: "작업시 비정상적인 작업자세를 금지하는가?(안전한 자세와 균형유지)",
        isChecked: "",
      },
      {
        content: "반동력을 견디기 위하여 양손으로 공구를 잡고, 작업시 날의 측면에 위치하는가?",
        isChecked: "",
      },
      {
        content: "톱날이 끼이거나 구속되어 정지시 임의로 움직이지 말고, 날이 완전히 멈추도록 손잡이를 놓고 정지상태에서 원인을 찾아 제거하는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "공기압축기",
    list: [
      {
        content: "압축기가 운전중일때에는 벨트커버나 회전부에 가까이 가지 않는가?",
        isChecked: "",
      },
      {
        content: "압축기를 작동하기 전에 압축기 주변에 다칠 위험이 있는 사람은 없는지 확인 후 가동하는가?",
        isChecked: "",
      },
      {
        content: "작업시작 전 점검 시 압력게이지, 온도계 등을 점검하여 공기압축기가 정상작동임을 확인하는가?",
        isChecked: "",
      },
      {
        content: "공기압축기는 정상적인 대기 공기많을 흡입하여 압축하도록 설계되어 있으므로 다른 종류의 가스, 기체, 증기류는 절대로 공기압축기에 흡수되거나 사용하지 않는가?",
        isChecked: "",
      },
      {
        content: "공기압축기의 정비작업 개시 전에 리모트 컨트롤러를 포함하여 모든 전원을 차단하는가?",
        isChecked: "",
      },
      {
        content: "압축기의 청소 정비시에는 반드시 압축기를 정지하고 모든 전원을 차단한 다음 내부압력이 완전히 방출된 후 충분히 냉각된 상태에서 실시하는가?",
        isChecked: "",
      },
      {
        content: "적합한 규격의 안전밸브를 설치하였는가?",
        isChecked: "",
      },
      {
        content: "안전밸브는 설정압력을 변경하거나 그 기능을 제한하거나 플러그 등으로 대체하지 않았는가?",
        isChecked: "",
      },
      {
        content: "공기압축기의 시스템 어느 부분에도 플라스틱 파이프, 고무호스의 사용 및 납땜을 하지 않았는가?",
        isChecked: "",
      },
      {
        content: "에어필터나 부품의 세척시 인화성 또는 독성이 있는 솔벤트, 신나 등의 사용을 금지하였는가?",
        isChecked: "",
      },
      {
        content: "공기압축기가 작동중일때에는 정비작업을 실시하지 않는가?",
        isChecked: "",
      },
      {
        content: "규정된 압력이상으로 공기압축기를 작동시키지 않는가?",
        isChecked: "",
      },
      {
        content: "공기압축기 작동중에는 보호커버나 판넬 등을 제거하지 않는가?",
        isChecked: "",
      },
      {
        content: "항상 공기압축기에 적합한 윤활유를 사용하고 교환주기를 지키는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "띠톱기계",
    list: [
      {
        content: "기계주변에 불필요한 물건이 없는지 확인하였는가?",
        isChecked: "",
      },
      {
        content: "비상정지스위치 기능을 확인하였는가?",
        isChecked: "",
      },
      {
        content: "원재료 작업량이 적정하게 준비 되었는지 확인하였는가?",
        isChecked: "",
      },
      {
        content: "담당자 이외에는 기계조작을 금지하였는가?",
        isChecked: "",
      },
      {
        content: "기계의 작동은 각 작업자의 위치를 확인하고 안전장치의 이상 유무를 확인한 후 실시하는가?",
        isChecked: "",
      },
      {
        content: "운전중에는 근무 위치 이탈 및 다른 작업을 금지하였는가?",
        isChecked: "",
      },
      {
        content: "띠톱기계 기동과 관련한 조작스위치를 정지위치에 두고 기동스위치를 차단하였는가?",
        isChecked: "",
      },
      {
        content: "띠톱 마멸여부, 누유상태, 오일게이지 급유상태, 동작부 풀림항태 등을 점검하였는가?",
        isChecked: "",
      },
      {
        content: "띠톱기계 주위에서의 미끄럼방지를 위해 물기·기름기는 신속하게 제거하였는가?",
        isChecked: "",
      },
      {
        content: "점검·수리작업 시에는 전원을 차단하고 꼬리표(Lock-out, Tag-out)를 부착하였는가?",
        isChecked: "",
      },
      {
        content: "작업자는 정해진 복장을 착용하고 소매나 바지 자락이닿지 않도록 하는가?",
        isChecked: "",
      },
      {
        content: "띠톱기계 운전은 유경험자로  하고, 담당자 이외에는 조작하는 않는가?",
        isChecked: "",
      },
      {
        content: "작업전 톱날에 금이 가거나 손상된 곳이 없는지 점검하고 금이가거나 손상된 날은 즉시교체하는가?",
        isChecked: "",
      },
      {
        content: "절단한 소재에 맞는 톱날을 선택하는가?",
        isChecked: "",
      },
      {
        content: "스위치를 켜기전 테이블에서 렌치나 절단 조각 등을 치우는가?",
        isChecked: "",
      },
      {
        content: "톱날선에 손을 대지 말고, 톱날이 지나가는 선에 작업자나 다른 사람이 서 있지 못하도록 하는가?",
        isChecked: "",
      },
      {
        content: "진동과 흔들림을 살펴보아 잘못 설치되었는지, 날의 균형이 맞느지를 확인하는가?",
        isChecked: "",
      },
      {
        content: "날 접촉방지 덮개가 파손되었을 경우 즉시 교환하는가?",
        isChecked: "",
      },
      {
        content: "띠톱기계를 보호하는 도어나 보호 커버가 열려 있을때에는 기계를 작동하지 않는가?",
        isChecked: "",
      },
      {
        content: "띠톱기계와 속도는 절단할 소재에 맞춰 선택하는가?",
        isChecked: "",
      },
      {
        content: "작동중에는 띠톱기계를 청소하지 않는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "구내운반차",
    list: [
      {
        content: "지정된 운전원 이외에는 운행하지 않는가?",
        isChecked: "",
      },
      {
        content: "근로자가 구내운반차 및 이동대차에 탑승하지 않는가?",
        isChecked: "",
      },
      {
        content: "운전원은 장비를 이탈할 때 엔진을 정지시키고, 제동 후 키를 뽑아 지정된 장소에 보관하는가?",
        isChecked: "",
      },
      {
        content: "허용 적재하중(견인하중)을 초과하여 운행하지 않는가?",
        isChecked: "",
      },
      {
        content: "작업계획에 따라 작업절차를 준수하는가?",
        isChecked: "",
      },
      {
        content: "운전시 급출발, 급정지 및 급회전을 하지 하지 않는가?",
        isChecked: "",
      },
      {
        content: "주행속도는 10km/h 이하로 하는가?",
        isChecked: "",
      },
      {
        content: "보행자가 있을 경우 진로를 양보하고, 건물이나 창고를 출입할 때와  운전원의 시야에 장해를 주는 곳에서는 서행하며 위험이 없음을 확인한 후 진행하는가?",
        isChecked: "",
      },
      {
        content: "후진 시에는 뒤를 잘 살피고 서행하는가?",
        isChecked: "",
      },
      {
        content: "구내운반차와 이동대차, 이동대차간의 다중연결 시 규정된 견인핀을 사용하는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "굴착기",
    list: [
      {
        content: "운전원 면허 자격이 있는가?<br/>- 3톤미만 : 소형건설기계 조종교육 이수,<br/>- 3톤이상 : 건설기계조종사면허",
        isChecked: "",
      },
      {
        content: "버킷 유압커플러 이탈방지장치(안전핀)는 체결상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "후진경보장치 및 후방카메라 작동상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "작업반경 내 근로자 접근통제조치를 한 경우 예외",
        isChecked: "",
      },
      {
        content: "붐, 유압장치, 선회장치 등 주요 구조부는 이상없는가?",
        isChecked: "",
      },
      {
        content: "트랙, 슈, 링크핀, 롤러상태, 타이어 손상 및 마모상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "운전자의 시야는 확보하는가?(전면 유리상태 및 후사경 설치상태)",
        isChecked: "",
      },
      {
        content: "운전석 조작장치 및 제동장치 등 작동하는가",
        isChecked: "",
      },
      {
        content: "운전원은 급선회 하는가?(작업반경 내 근로자 접근통제조치를 한 경우 예외)",
        isChecked: "",
      },
      {
        content: "상·하 동시작업을 금지하는가?",
        isChecked: "",
      },
      {
        content: "버킷에 근로자 탑승을 금지하는가?",
        isChecked: "",
      },
      {
        content: "노폭의 유지, 노견(굴착면, 경사면 포함) 무너짐 방지 및 지반 침하방지 조치를 하였는가?",
        isChecked: "",
      },
      {
        content: "운전원 이탈 시 버킷은 지상에 내려놓고 시동키는 차에서 분리 하였는가?",
        isChecked: "",
      },
      {
        content: "후진 시 깔림위험 예방대책을 포함한 작업계획서를 작성하였는가?",
        isChecked: "",
      },
      {
        content: "인양작업 할 시 제조사 작업설명서를 확인하고 따랐는가?",
        isChecked: "",
      },
      {
        content: "수리·점검항목 등 이력기록 관리상태는 이상없는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "트럭류",
    list: [
      {
        content: "운전원 면허 자격이 있는가?<br/>- 덤프트럭 : 1종 대형면허 소지, 건설기계조종사 면허 발급<br/>- 화물자동차 : 1종 대형면허(12톤 이상), 1종 보통면허(12톤 미만)",
        isChecked: "",
      },
      {
        content: "운전자의 시야는 확보하는가?(전면 유리상태 및 후사경 설치상태)",
        isChecked: "",
      },
      {
        content: "작업장 내 운행로와 보행로의 분리가 되어있는가?",
        isChecked: "",
      },
      {
        content: "주·정차시 브레이크를 체결하는가?(경사면인 경우 고임목 설치)",
        isChecked: "",
      },
      {
        content: "적재함에 근로자 탑승금지 및 과적금지 하는가?",
        isChecked: "",
      },
      {
        content: "현장 내 제한속도 표시 및 준수하는가?",
        isChecked: "",
      },
      {
        content: "운전자가 잘 볼 수 있는 위치에서 유도자(신호수)가 유도하는가?(신호수복장 착용, 차량유도봉·경광 등의 보조도구 사용)",
        isChecked: "",
      },
      {
        content: "안전벨트 설치 및 착용상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "주행 중 충돌·끼임 예방대책을 포함한 작업게획서를 작성하는가?",
        isChecked: "",
      },
      {
        content: "수리·점검항목 등 이력기록 관리상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "후진경보장치 및 후방카메라 작동상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "적재함 불시 하강방지용 안전블록 설치상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "전조등과 후미등 점등상태 및 혼(horn) 작동상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "소화기 및 고임대(2개이상) 구비·관리상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "유압장치, 조작장치 등 주요구조부 상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "주·정차시 제동장치 작동 및 시동키 분리하는가?",
        isChecked: "",
      },
      {
        content: "타이어 손상 및 마모상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "적재함 덮개 설치 및 사용상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "적재함 상승 및 하강 시 경고음 작동상태는 이상없는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "차량탑재형 고소작업대",
    list: [
      {
        content: "사전조사·작업계획서 작성, 수리·점검 등 이력기록 관리 및 안전검사 실시하는가?",
        isChecked: "",
      },
      {
        content: "운전원 면허 자격이 있는가?<br/>- 총중량 10톤미만 : 1종 보통<br/>- 총중량 10톤이상 : 1종 대형",
        isChecked: "",
      },
      {
        content: "임의 개조 및 안전장치 해제 사용금지를  하는가?",
        isChecked: "",
      },
      {
        content: "작업 시작 전 기계 이상유무 점검하는가?",
        isChecked: "",
      },
      {
        content: "유도자 및 신호수 배치(작업지휘자)를 하였는가?",
        isChecked: "",
      },
      {
        content: "탑승근로자 안전대 착용·부착 및 개인보호구 착용을 하였는가?",
        isChecked: "",
      },
      {
        content: "유압장치, 조작장치 등 주요구조부 상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "안전장치 통합컨트롤러는 이상없는가(안전장치 해제여부 확인)<br/>- 붐길이, 각도, 적재하중, 반경 등 제한",
        isChecked: "",
      },
      {
        content: "안전장치 작동상태모니터링 이상없는가?(작업반경 초과 운전시 정지여부 확인)<br/>- 붐길이, 각도, 적재하중, 반경 등 표시",
        isChecked: "",
      },
      {
        content: "과부하 방지장치(로드셀)는 이상없는가?(과부하시 정지여부 확인)<br/>- 작업대 탑승하중 측정 및 모니터링",
        isChecked: "",
      },
      {
        content: "붐각도센서는 이상없는가?(붐각도 변경시 모니터 정상작동여부 확인)",
        isChecked: "",
      },
      {
        content: "붐길이센서는 이상없는가?(붐길이 변경시 모니터 정상작동여부 확인)",
        isChecked: "",
      },
      {
        content: "자동안전장치는 이상없는가?(붐 상승상태에서 아우트리거 작동불가 확인)- 붐과 아우트리거 연동 인터록 장치",
        isChecked: "",
      },
      {
        content: "아우트리거 전복방지센서는 이상없는가?(전복방지센서 작동여부 확인)<br/>- 슬라이스 박스 하단, 상단 또는 잭실린더 상단 위치",
        isChecked: "",
      },
      {
        content: "붐, 턴테이블은 이상없는가?- 붐대 균열여부 확인 및 턴테이블 균열 및 체결볼트 풀림여부 확인)",
        isChecked: "",
      },
      {
        content: "작업대(탑승함)은 이상없는가?(작업대 고정볼트 풀림, 핀 탈락여부  확인 및 안전난간 휨, 찌그러짐, 파손사앹 확인)",
        isChecked: "",
      },
      {
        content: "아우트리거는 이상없는가?(잭·발판 고정, 완전 확장 및 유압호스 누설 여부 확인)",
        isChecked: "",
      },
      {
        content: "붐 인출 와이어 또는 체인은 이상없는가?(와이어 또는 체인 파손 여부 확인 및 인출 롤러의 마찰부 마모상태 확인)",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "이동식크레인",
    list: [
      {
        content: "사전조사·작업계획서 작성, 수리·점검 등 이력기록 관리 및 안전검사 실시하는가?",
        isChecked: "",
      },
      {
        content: "운전원 면허 자격이 있는가?<br/>- 기중기 : 건설기계조종사면허<br/>- 차량탑재형 : 1종 대형면허(12톤이상)<br/>- 이동식크레인 : 1종 보통면허(12톤미만)",
        isChecked: "",
      },
      {
        content: "불법탑승설비 부착 사용하는가?",
        isChecked: "",
      },
      {
        content: "유압발생장치는 이상없는가?(유압펌프의 이상음, 발열, 누설 여부 확인 및 작동유 탱크의 유량 및 오일 누설여부 확인)",
        isChecked: "",
      },
      {
        content: "조작장치는 이상없는가?(조작밸브, 레버의 작동, 오일 누설여부 확인 및 상·하부 조작부 작동상태, 스위치 등 동작상태 확인)",
        isChecked: "",
      },
      {
        content: "전도 임계하중 초과 사용하는가?(전도 발생 직전 크레인 붐 끝단에서 양중 할 수 있는 최대하중)",
        isChecked: "",
      },
      {
        content: "실린더 및 카운터밸런스 밸브 오일 누설 및 자연하강이 있는가?",
        isChecked: "",
      },
      {
        content: "붐의 균열, 변형, 손상 및 작동상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "아우트리거는 이상없는가?(외관의 균열, 변형, 손상여부, 작동상태 및 유압라인 오일 누성여부 확인)",
        isChecked: "",
      },
      {
        content: "훅 해지장치는 이상없는가?(설치 및 외관의 균열, 변형, 손상여부 및 회전상태 확인)",
        isChecked: "",
      },
      {
        content: "과부하방지장치 작동상태 확인하였는가?",
        isChecked: "",
      },
      {
        content: "권과방지장치 작동상태 확인하였는가?",
        isChecked: "",
      },
      {
        content: "비상정지장치 작동상태 확인하였는가?",
        isChecked: "",
      },
      {
        content: "유도자 및 신호수 배치하였는가?",
        isChecked: "",
      },
      {
        content: "줄걸이는 안전하게 작업하는가?(와이어로프 변형, 마모, 파손, 체결상태, 안전율, 이탈방지핀 등 확인)",
        isChecked: "",
      },
      {
        content: "수리·점검항목 등 이력 기록 관리상태는 이상없는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "지게차",
    list: [
      {
        content: "운전원 면허 자격이 있는가?<br/>- 3톤이상 : 건설기계조종사면허<br/>- 3톤미만 : 소형건설기계조종교육 이수<br/>- 건설기계관리법 비적용 지게차 : 지게차조종교육과정(12H)이수",
        isChecked: "",
      },
      {
        content: "자재 하역작업 외 사용금지하는가?",
        isChecked: "",
      },
      {
        content: "운전자의 시야 확보를 하는가?(화물 과다적재, 포크 과다상승 상태 운행금지)",
        isChecked: "",
      },
      {
        content: "포크에 화물을 매단 상태로 운행(급선회)하는가?",
        isChecked: "",
      },
      {
        content: "전용통로 확보 및 작업지휘자를 통한 작업자 출입제한을 하는가?(지게차 운행통로에 근로자 출입통제)",
        isChecked: "",
      },
      {
        content: "사업장 내 제한속도 지정 및 준수하는가?",
        isChecked: "",
      },
      {
        content: "후진시 협착위험 예방대책을 포함한 작업계획서 작성하였는가?",
        isChecked: "",
      },
      {
        content: "화물을 적재하고 경사지 오를 경우 전진주행, 내려갈 경우 후진주행 준수하는가?",
        isChecked: "",
      },
      {
        content: "승차석 외에 근로자 탑승운행금지 준수하는가?",
        isChecked: "",
      },
      {
        content: "유압장치(모터, 실린더, 배관 등) 누설, 손상 및 마모 상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "타이어 손상 및 마모 상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "수리·점검항목 등 이력기록 관리상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "화물 과다적재 및 편하중 적재하지 않는가?",
        isChecked: "",
      },
      {
        content: "좌석안전띠 설치 및 착용상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "전조등 및 후미등 점등상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "헤드가드 및 백레스트 설치상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "후방확인장치 설치상태는 이상없는가?(후사경, 룸미러, 후방경보장치, 후방카메라 등)",
        isChecked: "",
      },
      {
        content: "운행경로상의 사각지대 반사경 설치상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "운전석의 조작장치 및 제동장치 등 작동상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "포크 고정핀 설치·사용상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "카운트 웨이트 추가 금지 준수 및 고정상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "경사지 주차금지 준수하는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "호이스트 크레인",
    list: [
      {
        content: "인증된 제품을 사용하며 작업자가 볼 수 있는곳에 정격하중, 운전속도 및 경고표지를 부착하였는가?",
        isChecked: "",
      },
      {
        content: "호이스트 및 부속품이 습기 , 마모 또는 부식 환경으로부터 손상 또는 열화되었는지 주기적으로 확인 하였는가?",
        isChecked: "",
      },
      {
        content: "전기, 유압 또는 공압 등의 작동에너지를 공급하는 장치에 이상이 있는지 확인 하였는가?",
        isChecked: "",
      },
      {
        content: "모든 안전장치가 갖추어져 있고 설치된 안전장치가 정상기능을 유지하고 있는지 확인 하였는가?",
        isChecked: "",
      },
      {
        content: "안전장치를 해체시켜 안전기능을 무효화 하는걸 금지하고 있는가?",
        isChecked: "",
      },
      {
        content: "작업자가 작업에 적절한 개인보호구를 착용하였는가?",
        isChecked: "",
      },
      {
        content: "인양대상물의 무게가 호이스트 적격하중을 초과하지 않는지 확인하였는가?",
        isChecked: "",
      },
      {
        content: "인양대상물의 무게중심이 어디인지 확인 하였는가?",
        isChecked: "",
      },
      {
        content: "인양대상물을 어떻게 묶어 호이스트에 실을 것인지 고려 하였는가?",
        isChecked: "",
      },
      {
        content: "화물의 날카로운 모서리가 슬링벨트를 손실시킬 가능성이 있는 경우 포장하여 인양 하였는가?",
        isChecked: "",
      },
      {
        content: "화물취급 시 부적절한 줄걸이 도구(손상된 체인, 짧은 매듭의 슬링벨트, 꼬인 와이어로프 등)은 사용하지 않았는가?",
        isChecked: "",
      },
      {
        content: "기기 조정 및 청소 등으로 잠시 운전하지 않는 경우에는 안전하게 전원을 차단하고 제어 스위치에 잠금/표지의 조치를 실시 하였는가?",
        isChecked: "",
      },
      {
        content: "작업 시 느슨한 복장 등 호이스트 작동부에 말려 들어갈 수 있는 복장은 착용 금지 하였는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "기계식 주차장",
    list: [
      {
        content: "입·출차 차단기 정상작동 및 이상유무를 확인 하였는가?",
        isChecked: "",
      },
      {
        content: "차단기 바 부분에 차량의 서행 및 정지를 알리기 위한 안내표지를 부착하였는가?",
        isChecked: "",
      },
      {
        content: "주차관리부스 내부 및 주위에 정리정돈이 되어 있는가?",
        isChecked: "",
      },
      {
        content: "미끄럼방지조치를 하였는가?",
        isChecked: "",
      },
      {
        content: "점검·보수작업 수행 시 차단기를 개방하고 전원을 차단한 후 작업을 실시하였는가?",
        isChecked: "",
      },
      {
        content: "자동차대수 20대이상 기계식 주차장치에는 주차장치관리인 선임하였는가?",
        isChecked: "",
      },
      {
        content: "주차설비 사용매뉴얼, 도면 등 주차관리 사무실 내 비치 하였는가?",
        isChecked: "",
      },
      {
        content: "정비 등 작업 시 전원차단하고 다른 근로자 조작을 차단 하였는가?",
        isChecked: "",
      },
      {
        content: "개인보호구 구비 및 착용 하였는가?",
        isChecked: "",
      },
      {
        content: "주차설비 승강장 정면에는 안전수칙, 사용하중 등 부착하였는가?",
        isChecked: "",
      },
      {
        content: "주차설비 출입문 연동장치 및 비상정지장치는 정상작동 확인하였는가?",
        isChecked: "",
      },
      {
        content: "주차설비 운행 중 경보음의 정상작동 여부 확인하였는가?",
        isChecked: "",
      },
      {
        content: "주차장 바닥의 물기나, 오일 등은 발견 즉시 제거하였는가?",
        isChecked: "",
      },
      {
        content: "지하주차장 등 어두운장소 75Lux이상 조도를 확보 하였는가?",
        isChecked: "",
      },
      {
        content: "주차장관리원은 야광조끼를 착용하고 안전화를 착용하였는가?",
        isChecked: "",
      },
      {
        content: "주차설비는 주차관리인이 조작하고 가동 중지 시에는 가동키를 제거하고 별도 보관하였는가?",
        isChecked: "",
      },
      {
        content: "사다리는 작업특성에 적합한 것을 선정하고 아웃트리거 등이 설치된 안전 사다리를 사용하며 2인 1조로 작업하였는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "비상발전기",
    list: [
      {
        content: "충전부 접촉에 대비하여 절연보호구를 착용하는가?",
        isChecked: "",
      },
      {
        content: "외부인 출입금지 조치를 하고 있는가?",
        isChecked: "",
      },
      {
        content: "점검·정비 시 전원차단 후 실시하고 임의 가동을 방지하기 위한 잠금조치 부착을 하고 있는가?",
        isChecked: "",
      },
      {
        content: "동력전달부 방호덮개 이상유무를 확인하고 방호덮개 임의 제거 금지하고 있는가?",
        isChecked: "",
      },
      {
        content: "비상발전기 주변 화학물질, 이물질, 장애물에 의한 미끄러짐, 전도 등의 위험이 없도록 정리정돈을 하고 있는가?",
        isChecked: "",
      },
      {
        content: "배터리 폭팔위험에 대비하여 방호 덮개가 부착되어 있는가?",
        isChecked: "",
      },
      {
        content: "주변 개구부 덮개가 잘 설치 되어 있는가?",
        isChecked: "",
      },
      {
        content: "주변 정리정돈 및 통행로가 적정한가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "승강기 유지관리",
    list: [
      {
        content: "개인보호구 (안전모,안전화,안전벨트) 등 착용하였는가?",
        isChecked: "",
      },
      {
        content: "추락위험이 있는 곳 추락방지조치를 하였는가?",
        isChecked: "",
      },
      {
        content: "점검 시 조도 확보를 하였는가?",
        isChecked: "",
      },
      {
        content: "전원이 필요없는 작업을 할 경우 전원을 차단하고 작업하였는가?",
        isChecked: "",
      },
      {
        content: "회전체 끼임점 주변에 공구 등을 두지 않고 신체접촉이 되지 않도록 안전커버를 설치 하였는가?",
        isChecked: "",
      },
      {
        content: "작업지휘자 지정하고 지휘하에 작업 실시하였는가?",
        isChecked: "",
      },
      {
        content: "승강로 내부에서 작업 시 출입구에 안전펜스를 설치 하였는가?",
        isChecked: "",
      },
      {
        content: "카 운행 시 조속기와 비상정치장치가 작동하는가?",
        isChecked: "",
      },
      {
        content: "인증된 작업발판을 사용하고 있는가?",
        isChecked: "",
      },
      {
        content: "상·하 동시작업을 금지하고 있는가?",
        isChecked: "",
      },
      {
        content: "기계실 진입 계단에 장애물 또는 자재를 적재하지 않았는가?",
        isChecked: "",
      },
      {
        content: "기계실 외부인 접근을 통제 하였는가?",
        isChecked: "",
      },
      {
        content: "승강기 제어반 메인전원 차단 후 테스트키로 잔류전류 확인하고 작업하는가?",
        isChecked: "",
      },
      {
        content: "분전함 제어반은 작업 종료 후 잠금조치를 하였는가?",
        isChecked: "",
      },
      {
        content: "분전함 방호장치는 적절하게 설치되어 있는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "보일러 유지관리",
    list: [
      {
        content: "점화 전 충분히 환기",
        isChecked: "",
      },
      {
        content: "급수탱크의 수위가 정상상태인지 수시로 확인하는가?",
        isChecked: "",
      },
      {
        content: "점화에 실패한 경우 계속해서 연료를 공급하지 말고 환기 후 다시 점화 하는가?",
        isChecked: "",
      },
      {
        content: "기기를 가동시킬 떄 주위를 정돈하고, 불피요한 물건을 제거 한 후 조작 하는가?",
        isChecked: "",
      },
      {
        content: "보일러 소음으로 인한 청력손실 예방을 위해 귀마개 귀덮개 를 착용하는가?",
        isChecked: "",
      },
      {
        content: "노내의 점검 시에는 입회인을 꼭 대기시킨후 작업 실시하는가?",
        isChecked: "",
      },
      {
        content: "보일러 내에서 증발이 시작되면 소정압력에 달할 떄까지 보일러 압력,수위의 움직임 및 연소상태 감시하는가?",
        isChecked: "",
      },
      {
        content: "일정압력으로 상승 후 수면 측정장치의 기능, 수위검출기의 작동상황, 연료차단 기능 등을 점검 후 송기 시작하는가?",
        isChecked: "",
      },
      {
        content: "운전 중 다른 사정으로 수위 확인이 불가능 할 경우 일단 보일러 운전을 정지한 후 원인을 파악하는가?",
        isChecked: "",
      },
      {
        content: "수위검출기나 조절기 수면계를 수시로 확인하는가?",
        isChecked: "",
      },
      {
        content: "분진, 퇴적 매연에 의한 착화를 방지하는가?",
        isChecked: "",
      },
      {
        content: "버너의 청소를 주기적으로 실시하는가?",
        isChecked: "",
      },
      {
        content: "연소 안전장치는 그 기능을 잃은채로 보일러 운전 감행을 금지",
        isChecked: "",
      },
      {
        content: "화염검출기로 화염의 유무를 검출하고, 검출부의 오손,소손등의 유무 및 검출기능을 점검하는가?",
        isChecked: "",
      },
      {
        content: "연료차단밸브는 정기적으로 그 기능, 누설 및 이물질의 유무를 점검하고 청소 하는가?",
        isChecked: "",
      },
      {
        content: "조정,정비,수리,청소 등 작업 시 잠금장치 및 표지판을 설치하는가?",
        isChecked: "",
      },
      {
        content: "정비 등을 위한 계단, 사다리 ,작업발판 등 안전 시설 적정상태를 확인하는가?",
        isChecked: "",
      },
      {
        content: "보일러 실 조도 확보 및 전도 방지 시설이 적절하게 설치 되어 있는가?",
        isChecked: "",
      },
      {
        content: "보일러실에 신속한 화재진압을 위한 소화설비가 구비되어 있는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "음식물 폐기물",
    list: [
      {
        content: "작업 중 담배를 물고 작업하지 않는가?",
        isChecked: "",
      },
      {
        content: "개인보호구 착용하고 작업을 하는가? (안전모,안전화,안전장갑 등)",
        isChecked: "",
      },
      {
        content: "3륜오토바이 사용 시 장비 점검을 주기적으로 하고 있는가?",
        isChecked: "",
      },
      {
        content: "단독작업인 경우 근로자가 무리하지 않고 운반 할 수있도록 대차,수거량 조절을 할 수 있는가?",
        isChecked: "",
      },
      {
        content: "야간반사조끼를 착용하고 작업하고 있는가?",
        isChecked: "",
      },
      {
        content: "위생시설 관리상태는 양호한가?",
        isChecked: "",
      },
      {
        content: "무거운 쓰레기를 무리하게 혼자 들지 않는가?",
        isChecked: "",
      },
      {
        content: "작업종료 후 개인 위생을 철저히 하고 있는가?",
        isChecked: "",
      },
      {
        content: "위생시설 관리상태는 양호한가?",
        isChecked: "",
      },
      {
        content: "구급함 관리를 잘하고 있는가?",
        isChecked: "",
      },
      {
        content: "5ton 음식물 쓰레기 수거차량 후방, 측방 의 시야확보의 위해 영상장치를 설치하고 사용하고 있는가?",
        isChecked: "",
      },
      {
        content: "적재함 덮개 조작을 위한 차량 후미에 양수조작방식으로 설치 되어 있는가?",
        isChecked: "",
      },
      {
        content: "회전판 구동부, 리프트체인 (동력부 전달부) 등에 덮개 또는 울 등이 설치 되어 있는가?",
        isChecked: "",
      },
      {
        content: "디젤 매연 배기구 위치가 또는 배기 방향이 작업중인 미화원에게 영향을 주지 않도록 위치 또는 방향을 조정하는가?",
        isChecked: "",
      },
      {
        content: "차량 후진 시 경보장치가 정상적으로 작동하는가?",
        isChecked: "",
      },
      {
        content: "차량 브레이크, 조명, 조향장치, 등 모든 부품의 안전한 작동을 확보하기 위해 정기적으로 검사를 시행하고 있는가?",
        isChecked: "",
      },
      {
        content: "화물차 작업계획서 수립 비치 하였는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "생활폐기물(압착진개차)",
    list: [
      {
        content: "압착 진개차가 후방,측방의 시야확보를 위해 영상장치를 설치하고, 사용하고 있는가?",
        isChecked: "",
      },
      {
        content: "적재함덮개(파카,테일게이트) 조작을 위한 스위치는 차량 후미에 양수조작방식으로 설치 사용되고 있는가?",
        isChecked: "",
      },
      {
        content: "차량 측면 또는 후면에 작업자가 탑승 할 수 있도록 만든 발판을 제거하였는가?",
        isChecked: "",
      },
      {
        content: "회전판에 신체접촉 등 응급상활발생 시 전원을 차단할 수 있는 비상정치버튼이 설치 되어 있는가?",
        isChecked: "",
      },
      {
        content: "회전판 구동부에 덮개 또는 울 등이 설치되어 있는가?",
        isChecked: "",
      },
      {
        content: "디젤매연 배기구 위치 또는 배기방향을 작업중인 미화원에게 영향을 주지 않도록 위치 또는 방향을 조정하였는가?",
        isChecked: "",
      },
      {
        content: "차량 후진 시 경보장치가 정상적으로 작동하는가?",
        isChecked: "",
      },
      {
        content: "차량의 브레이크, 조명, 조향장치 등 모든 부품의 안전한 작동을 확보하기 위해 정기적으로 검사를 하였는가?",
        isChecked: "",
      },
      {
        content: "차량 운행 시 안전 운행 속도 등 교통안전수칙을 준수하는가?",
        isChecked: "",
      },
      {
        content: "골목에서 서행하는가?",
        isChecked: "",
      },
      {
        content: "운전석에서 내릴 떄는 브레이크를 채우고 시동키를 운전대에서 분리 시키는가?",
        isChecked: "",
      },
      {
        content: "작업계획서에 따라 작업이 이루어 지고 있는가?",
        isChecked: "",
      },
      {
        content: "신호수, 작업지휘자에 따라 작업이 이루어지고 있는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "종량제 수거작업",
    list: [
      {
        content: "작업 중 담배를 물고 작업하지 않는가?",
        isChecked: "",
      },
      {
        content: "개인보호구 착용하고 작업을 하는가? (안전모,안전화,안전장갑 등)",
        isChecked: "",
      },
      {
        content: "안전모 착용 시 턱끈을 알맞게 조이고 착용하는가?",
        isChecked: "",
      },
      {
        content: "야간반사조끼를 착용하고 작업하고 있는가?",
        isChecked: "",
      },
      {
        content: "위생시설 관리상태는 양호한가?",
        isChecked: "",
      },
      {
        content: "무거운 쓰레기를 무리하게 혼자 들지 않는가?",
        isChecked: "",
      },
      {
        content: "상차를 위해 종량제봉투를 잡을 떄 묶음선을 이용하는가?",
        isChecked: "",
      },
      {
        content: "회전판의 회전반경 내로 손이나 발을 집어 넣지 않는가?",
        isChecked: "",
      },
      {
        content: "작업종료 후 개인 위생을 철저히 하고 있는가?",
        isChecked: "",
      },
      {
        content: "조도확보 및 종량제 안 날카로운 물건이 있는지 확인하는가?",
        isChecked: "",
      },
      {
        content: "구급함 관리를 잘하고 있는가?",
        isChecked: "",
      },
      {
        content: "조도확보 및 종량제 안 날카로운 물건이 있는지 확인하는가?",
        isChecked: "",
      },
      {
        content: "위생시설 관리상태는 양호한가?",
        isChecked: "",
      },
      {
        content: "화물차 작업계획서 수립 비치 하였는가?",
        isChecked: "",
      },
      {
        content: "옥외작업 시 계절별 질환에 따른 보건조치를 하였는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "가로청소",
    list: [
      {
        content: "청소 및 이동 시 노면의 바닥상태나 이물질을 확인하는가?",
        isChecked: "",
      },
      {
        content: "적정한 개인 보호구를 착용하고 있는가?",
        isChecked: "",
      },
      {
        content: "인도 -> 도로 , 도로->인도 이동 시 경계석을 주의하여 이동하는가?",
        isChecked: "",
      },
      {
        content: "도로 횡단 시 횡단보도로 건너는 등 교통안전수칙을 준수하고 있는가?",
        isChecked: "",
      },
      {
        content: "도로 변 청소 시 반사조끼를 착용하고 있는가?",
        isChecked: "",
      },
      {
        content: "쓰레기 봉투 내 유리조각 등 날카로운 것이 있는지 확인 하는가?",
        isChecked: "",
      },
      {
        content: "작업 시 피부노출을 최소화하고 개인위생을 잘 관리하고 있는가?",
        isChecked: "",
      },
      {
        content: "계단 이동 시 핸드레일을 잡고 이동하는 등 넘어지지 않도록 주의하는가?",
        isChecked: "",
      },
      {
        content: "구급함관리를 하고 있는가?",
        isChecked: "",
      },
      {
        content: "옥외작업 시 계절별 질환에 따른 보건조치를 하였는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "동절기 화재예방",
    list: [
      {
        content: "화재 진압장비는 적절하게 구비 되어 있는가?",
        isChecked: "",
      },
      {
        content: "소화기는 적정 압력 및 사용기한이 유효한가?",
        isChecked: "",
      },
      {
        content: "근로자가 소화기 위치 및 사용방법을 숙지하고 있는가?",
        isChecked: "",
      },
      {
        content: "전열기구 주위에 인화성 물질이나 위험한 물건이 없는가?",
        isChecked: "",
      },
      {
        content: "전열기구 임의 조작•수리 등을 하지 않았는가? ",
        isChecked: "",
      },
      {
        content: "전열기구 벽이랑 1M 이상 이격거리를 준수하였는가",
        isChecked: "",
      },
      {
        content: "전열기구 사용 장소 주변 물기나 습기가 없는가?",
        isChecked: "",
      },
      {
        content: "전기 누전차단기 작동상태는 양호한가?",
        isChecked: "",
      },
      {
        content: "전선의 피복상태가 불량하여 스파크에 의한 화재의 위험성은 없는가?",
        isChecked: "",
      },
      {
        content: "하나의 콘센트에 다량의 플러그가 연결되어 과전류에 의한 화재의 위험성은 없는가 ?",
        isChecked: "",
      },
      {
        content: "사무실 및 창고 내․외부 정리정돈 상태는 양호한가?",
        isChecked: "",
      },
      {
        content: "화재발생 시 비상구 및 피난계단에 물건을 두지 않는 등 피난로를 확보하고 있는가?",
        isChecked: "",
      },
      {
        content: "퇴근 시 전열기구 점검하고 있는가?",
        isChecked: "",
      },
    ],
  },
];
